import { render, staticRenderFns } from "./AssetsTableSelectors.vue?vue&type=template&id=11cf06e9&"
import script from "./AssetsTableSelectors.vue?vue&type=script&lang=ts&"
export * from "./AssetsTableSelectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports